import adminGetters from "./getters.js";
import adminMutations from "./mutations.js";
import adminActions from "./actions.js";

export default {
  namespaced: true,
  state() {
    return {
      adminId: null,
      companyId: null,
      accountsTimestamp: null,
      companies: [],
      users: [],
    };
  },
  getters: adminGetters,
  mutations: adminMutations,
  actions: adminActions,
};
